import { FC } from "preact/compat";
import { SlideText } from "~/components";
import { CurrentTimeProps } from "./interfaces";

const CurrentTime: FC<CurrentTimeProps> = ({ now }) => {
    const hours = now.value.getHours();
    const minutes = now.value.getMinutes();
    const h0 = Math.floor(hours / 10);
    const h1 = hours % 10;
    const m0 = Math.floor(minutes / 10);
    const m1 = minutes % 10;

    return (
        <div className="flex">
            <SlideText>{h0}</SlideText>
            <SlideText>{h1}</SlideText>
            <span>:</span>
            <SlideText>{m0}</SlideText>
            <SlideText>{m1}</SlideText>
        </div>
    );
};

export default CurrentTime;
